import { Phone, Mail, MessageSquare, Globe } from "lucide-react";

export const STATUS_META = {
  new: { label: "New", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  in_review: { label: "In Review", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  awaiting_customer: { label: "Awaiting Customer", cls: "border-violet-200 text-violet-600 dark:border-violet-500/30 dark:text-violet-400" },
  qualified: { label: "Qualified", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  closed: { label: "Closed", cls: "border-slate-200 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  duplicate: { label: "Duplicate", cls: "border-slate-300 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  spam: { label: "Spam", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
  declined: { label: "Declined", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
  out_of_service_area: { label: "Out of Service Area", cls: "border-orange-200 text-orange-600 dark:border-orange-500/30 dark:text-orange-400" },
};

export const MANUAL_STATUSES = Object.keys(STATUS_META).filter((k) => k !== "qualified");
export const NON_QUALIFIABLE_STATUSES = new Set(["qualified", "closed", "duplicate", "spam", "declined"]);

export const SOURCE_META = {
  nova_form: { label: "Nova Form", icon: Globe },
  phone: { label: "Phone", icon: Phone },
  sms: { label: "SMS/Text", icon: MessageSquare },
  email: { label: "Email", icon: Mail },
  website_chat: { label: "Website Chat", icon: Globe },
};

export const channelForContactMethod = (method) => {
  if (method === "Phone" || method === "Text") return "sms";
  if (method === "Email") return "email";
  return null;
};

export const contactMethodIcon = (method) => {
  if (method === "Phone") return Phone;
  if (method === "Text") return MessageSquare;
  if (method === "Email") return Mail;
  return null;
};

export const serviceAreaLabel = (result) => {
  if (!result || result.status === "unknown") return { label: "Unable to determine", cls: "text-slate-400" };
  if (result.status === "within") return { label: result.service_area_name, cls: "text-emerald-600 dark:text-emerald-400" };
  if (result.status === "ambiguous") return { label: `${result.service_area_name} (ambiguous)`, cls: "text-amber-600 dark:text-amber-400" };
  return { label: "Outside service area", cls: "text-red-500 dark:text-red-400" };
};
